import React, { useState, useEffect, useContext, useCallback } from "react";

import { getScenarios } from "../../services/api";
import { EmissionContext } from "../emission";

import { Checkbox, Slider, Space } from "antd";
import GainButton from "../../components/objects/GainButton";
import GainSelect from "../../components/objects/GainSelect";
import GainIcon from "../../components/gainicon";

export default function Filter() {
  const Sheets = [
    {
      name: "PM2.5",
      value: "Result_PM2.5",
    },
    {
      name: "PM10",
      value: "Result_PM10",
    },
    {
      name: "NOx",
      value: "Result_NOx",
    },
    {
      name: "CO",
      value: "Result_CO",
    },
    {
      name: "NH3",
      value: "Result_NH3",
    },
    {
      name: "CH4",
      value: "Result_CH4",
    },
    {
      name: "N2O",
      value: "Result_N2O",
    },
    {
      name: "NMVOC",
      value: "Result_NMVOC",
    },
  ];
  const Technology = [
    "HDEUI",
    "HDEUII",
    "HDEUIII",
    "HDEUIV",
    "HDEUV",
    "HDEUVI",
    "HDEUVII",
    "HDSEI",
    "HDSEII",
    "HDSEIII",
    "LFEUI",
    "LFEUII",
    "LFEUIII",
    "LFEUIV",
    "LFEUV",
    "LFEUVI",
    "MDEUI",
    "MDEUII",
    "MDEUIII",
    "MDEUIV",
    "MDEUV",
    "MDEUVI",
    "MDEUVII",
    "MDEUVIp",
    "MOT4I",
    "MOT4II",
    "MOT4III",
    "NSC_TRA",
  ];
  const { defaults, filterData, setFilterData, EmissionData } =
    useContext(EmissionContext);
  const [Filters, setFilters] = useState(filterData);
  const [Scenarios, setScenarios] = useState();

  useEffect(() => {
    scenarioLists();
  }, []);

  useEffect(() => {
    setFilters(filterData);
  }, [filterData]);

  const scenarioLists = async () => {
    const slice = 1;
    const res = await getScenarios();
    if (res.status === 200) {
      const sc_option = res.data.map((option) => ({
        id: option.id,
        name: option.scenario_name,
        value: option.file_name,
      }));
      const options = res.data.map((option) => ({
        name: option.scenario_name,
        file: option.file_name,
      }));
      setScenarios(sc_option);
      setFilters({
        ...Filters,
        scenarios: options.slice(0, slice),
      });
      EmissionData(options.slice(0, slice));

      setFilterData({
        ...Filters,
        scenarios: options.slice(0, slice),
      });
    } else {
      console.error(res.statusText);
    }
  };

  const Show = () => {
    setFilterData(Filters);
  };

  return (
    <Space direction="vertical" size="large">
      <div
        className="cursor-pointer float-right"
        onClick={() => {
          setFilters(defaults);
        }}
      >
        <GainIcon name="refresh" />
      </div>
      <div>
        <GainSelect
          label={<span className="font-bold">Emission</span>}
          options={Sheets}
          value={Filters.sheet}
          onChange={(val) => setFilters({ ...Filters, sheet: val })}
          nospace
        />
      </div>
      <div>
        <GainSelect
          label={<span className="font-bold">Scenarios</span>}
          options={Scenarios}
          nospace
          multiple
          onChange={(val) => {
            const sc = Scenarios.filter((sc) => val.includes(sc.value)).map(
              ({ name, value }) => ({ name, file: value })
            );
            setFilters({ ...Filters, scenarios: sc });
          }}
          value={Filters.scenarios.map(({ file }) => file)}
        />
      </div>
      <div>
        <div className="font-bold text-base">Vaehicle type</div>
        <GainSelect
          options={Technology.map((item) => ({ name: item, value: item }))}
          multiple
          nospace
          onChange={(val) => setFilters({ ...Filters, technologies: val })}
          value={Filters.technologies}
          maxTagCount={true}
        />
      </div>
      <div>
        <h1 className="font-bold text-base pt-6">Fuel type</h1>
        <Checkbox.Group
          style={{ width: "100%" }}
          name="activity"
          onChange={(val) => setFilters({ ...Filters, activities: val })}
          value={Filters.activities}
        >
          <div className="grid grid-cols-2">
            <Checkbox value="GAS">GAS</Checkbox>
            <Checkbox value="GSL">GSL</Checkbox>
            <Checkbox value="LPG">LPG</Checkbox>
            <Checkbox value="MD">MD</Checkbox>
          </div>
        </Checkbox.Group>
      </div>
      <div>
        <div className="font-bold text-base">Region</div>
        <GainSelect
          nospace
          options={[
            {
              name: "Thailand",
              value: "Thailand",
            },
          ]}
          default="Thailand"
        />
        <GainSelect
          nospace
          options={[
            {
              name: "BMR",
              value: "BMR",
            },
          ]}
          default="BMR"
        />
      </div>
      <div>
        <h1 className="font-bold text-base pt-6">
          Year{" "}
          <span className="font-normal text-sm">{`( ${Filters.rangestart} - ${Filters.rangeend} )`}</span>
        </h1>
        <Slider
          range
          tipFormatter={(val) => val + 2010}
          max={40}
          value={[Filters.rangestart - 2010, Filters.rangeend - 2010]}
          onChange={(val) =>
            setFilters({
              ...Filters,
              rangestart: val[0] + 2010,
              rangeend: val[1] + 2010,
            })
          }
        />
      </div>
      <div>
        <h1 className="font-bold text-base pt-6">Sector</h1>
        <Checkbox.Group
          style={{ width: "100%" }}
          onChange={(val) => setFilters({ ...Filters, sectors: val })}
          value={Filters.sectors}
        >
          <div className="grid grid-cols-1">
            <Checkbox value="TRA_RD_HDB">TRA_RD_HDB</Checkbox>
            <Checkbox value="TRA_RD_HDT">TRA_RD_HDT</Checkbox>
            <Checkbox value="TRA_RD_LD4C">TRA_RD_LD4C</Checkbox>
            <Checkbox value="TRA_RD_LD4T">TRA_RD_LD4T</Checkbox>
            <Checkbox value="TRA_RD_M4">TRA_RD_M4</Checkbox>
          </div>
        </Checkbox.Group>
      </div>
      <div className="w-full pb-4" onClick={Show}>
        <GainButton label="Show" center />
      </div>
    </Space>
  );
}
